import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Entity } from '../../../../entities/entity';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { AccountContactMergeData } from '../data/account.contact.merge.data';
import { AccountMergeData, AccountMergeSchema } from '../data/account.merge.data';
import { BasicSiteMergeData, BasicSiteMergeSchema } from '../data/basic.site.merge.data';
import { CompanyMergeData, CompanyMergeSchema } from '../data/company.merge.data';
import { ContactMergeData, ContactMergeSchema } from '../data/contact.merge.data';
import { SaleOrderItemsMergeData, SaleOrderItemsMergeDataSchema } from '../data/sale.order.items.merge.data';
import { SaleOrderMergeData, SaleOrderMergeSchema } from '../data/sale.order.merge.data';

@MergeDataset({
    entity: ActivityEntityName.SaleOrder,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class SaleOrderMergeDataset {

    @MergeSource({
        schema: SaleOrderMergeSchema
    })
    saleOrder?: SaleOrderMergeData;

    @MergeSource({
        schema: AccountMergeSchema,
        displayName: "Sale Order Customer"
    })
    customer?: AccountMergeData;

    @MergeSource({
        schema: ContactMergeSchema,
        displayName: "Sale Order Customer Contact"
    })
    customerContact?: AccountContactMergeData;

    @MergeSource({
        schema: CompanyMergeSchema,
        displayName: "Sale Order Billing Company"
    })
    billingCompany?: CompanyMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    saleOrderJobSite?: BasicSiteMergeData;

    @MergeSource({
        schema: SaleOrderItemsMergeDataSchema
    })
    saleOrderItem?: SaleOrderItemsMergeData;

    public theme: Entity;
}